import { useTheme } from "@mui/material";
import DSAvatar from "../../system-design/DSAvatar";

const CollectionsListAvatar = ({
  collectionCover,
}: {
  collectionCover?: string;
}) => {
  const { spacing } = useTheme();
  return (
    <DSAvatar
      src={collectionCover}
      sx={{
        width: spacing(10),
        height: spacing(10),
        // Side ÷ 3, same rule as the studio covers (TK-711).
        borderRadius: "33.333%",
      }}
    />
  );
};

export default CollectionsListAvatar;
